import HttpService from "@core/services/http/http.service";
import { EndpointConversion, GetListResponse, ModelTrain } from "@app/types";
import { Signal } from "@core/services/http/http.type";

class _VoiceConvertService {
  public getEndpointConversions(signal?: Signal, isShowLoading?: boolean) {
    return HttpService.get<GetListResponse<EndpointConversion>>(
      "/admin/api/v1/voice-convert/endpoints",
      {
        signal,
        isShowLoading,
      }
    );
  }

  public getModelTrains(signal?: Signal, isShowLoading?: boolean) {
    return HttpService.get<GetListResponse<ModelTrain>>(
      "/admin/api/v1/voice-convert/model-train",
      {
        signal,
        isShowLoading,
      }
    );
  }
}

const VoiceConvertService = new _VoiceConvertService();

export default VoiceConvertService;
